import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";
import { mediaUrl } from "../../../../core/helpers/CoreHelpers";
import menuImage from "../../../assets/images/menu.png";
import { useCheckObjectDepth } from "../../../helpers/hooks/useCheckObjectDepth";

const Link = ({ item, secondLevel }) => {
    const hasChildren = item.children.length > 0;
    const href =
        item.data.link &&
        (item.data.link.contentId
            ? `/page/${item.data.link.contentId}`
            : item.data.link.url);

    return (
        <a href={href} target={item.data.linkTarget ? "_blank" : ""} tabIndex={0}>
            {item.data.title}{" "}
            {hasChildren && (
                <FontAwesomeIcon
                    icon={secondLevel ? faChevronRight : faChevronDown}
                />
            )}
        </a>
    );
};

export const MenuBlockWithoutRouter = (props) => {
    const { relatedContents } = props;
    let objectDepth;

    const addMenuClass = () => {
        return `menu-tier-${objectDepth}`;
    };

    const renderChildren = (children) => {
        if (children.length > 0) {
            return (
                <ul>
                    {children.map((item) => {
                        if (item.status === 1) {
                            return (
                                <li
                                    className={item.sortIndex}
                                    key={item.data.title}
                                >
                                    <Link item={item} secondLevel />
                                    {renderChildren(item.children)}
                                </li>
                            );
                        }
                        return null;
                    })}
                </ul>
            );
        }

        return null;
    };

    const renderMegaMenu = (item, image) => {
        if (item.status === 1) {
            return (
                <div className={`mega-menu ${addMenuClass()}`}>
                    <div className="sub-menu">
                        {renderChildren(item.children)}
                    </div>
                    <div className="image">
                        {image ? (
                            <img src={mediaUrl(image)} alt={item.data.title} />
                        ) : (
                            <img src={menuImage} alt={item.data.title} />
                        )}
                    </div>
                </div>
            );
        }
    };

    const renderMenuTopLevelItem = (item, image) => {
        const hasChildren = item.children.length > 0;

        if (item.status === 1) {
            useCheckObjectDepth(item.children);
            return (
                <li
                    key={item.id}
                    className={`
                        ${hasChildren > 0 ? "has-children" : "no-children"}
                        ${hasChildren && objectDepth === 1 ? "tooltip" : ""}
                    `}
                >
                    <Link item={item} />

                    {hasChildren && renderMegaMenu(item, image)}
                </li>
            );
        }
    };

    return (
        <div className={`menu menu__without-router`}>
            <ul className="top-level">
                {relatedContents[0].children.map((item) =>
                    renderMenuTopLevelItem(item, relatedContents[0].image)
                )}
            </ul>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/MenuBlock/MenuBlockWithoutRouter.js